import { render, staticRenderFns } from "./super_admin.vue?vue&type=template&id=65cab4c8&scoped=true"
import script from "./super_admin.vue?vue&type=script&lang=js"
export * from "./super_admin.vue?vue&type=script&lang=js"
import style0 from "./super_admin.vue?vue&type=style&index=0&id=65cab4c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cab4c8",
  null
  
)

export default component.exports